import { TRoutes } from '~/routes/const'
import { routeNames } from '../const'

export default [
  // {
  //   path: routeNames.userTagsConfig,
  //   component: () => import('../../pages/homeManagement/userTagsConfig/list'),
  //   meta: { title: '新用户选择标签配置' }
  // },
  {
    path: routeNames.bannerManagement,
    component: () => import('../../pages/homeManagement/bannerManagement/list'),
    meta: { title: 'banner管理' }
  },
  {
    path: routeNames.bannerManagementEdit,
    component: () => import('../../pages/homeManagement/bannerManagement/edit'),
    meta: { title: 'banner管理', hideInMenu: true }
  },
  {
    path: routeNames.modalManagement,
    component: () => import('../../pages/homeManagement/bannerManagement/modalList'),
    meta: { title: '弹窗广告管理' }
  },
  {
    path: routeNames.modalManagementEdit,
    component: () => import('../../pages/homeManagement/bannerManagement/modalEdit'),
    meta: { title: '弹窗广告管理', hideInMenu: true }
  },
  {
    path: routeNames.anchorModal,
    component: () => import('../../pages/homeManagement/anchorModal/list'),
    meta: { title: '主播互动弹框' }
  },
  {
    path: routeNames.anchorModalEdit,
    component: () => import('../../pages/homeManagement/anchorModal/edit'),
    meta: { title: '主播互动弹框', hideInMenu: true }
  },
  {
    path: routeNames.hotManagement,
    component: () => import('../../pages/homeManagement/hotManagement/list'),
    meta: { title: '热门活动管理' }
  },
  {
    path: routeNames.hotManagementEdit,
    component: () => import('../../pages/homeManagement/hotManagement/edit'),
    meta: { title: '热门活动管理', hideInMenu: true }
  },
  {
    path: routeNames.waterfallFlowManagement,
    component: () => import('../../pages/homeManagement/waterfallFlowManagement/list'),
    meta: { title: '瀑布流广告位管理' }
  },
  {
    path: routeNames.waterfallFlowManagementEdit,
    component: () => import('../../pages/homeManagement/waterfallFlowManagement/edit'),
    meta: { title: '瀑布流广告位管理', hideInMenu: true }
  },
  {
    path: routeNames.specialBanner,
    component: () => import('../../pages/homeManagement/specialBanner'),
    meta: { title: '专题页banner' }
  },
  {
    path: routeNames.specialHotBanner,
    component: () => import('../../pages/homeManagement/specialHotBanner'),
    meta: { title: '专题页热门推荐banner' }
  },
  {
    path: routeNames.editBanner,
    component: () => import('../../components/editBanner'),
    meta: { title: '编辑banner', hideInMenu: true }
  },
  {
    path: routeNames.activitiesBanner,
    component: () => import('../../pages/homeManagement/activitiesBanner'),
    meta: { title: '活动广告管理' }
  }
  // {
  //   path: routeNames.hotCircle,
  //   component: () => import('../../pages/homeManagement/hotCircle/list'),
  //   meta: { title: '热门圈子' }
  // },
  // {
  //   path: routeNames.hotTopic,
  //   component: () => import('../../pages/homeManagement/hotTopic/list'),
  //   meta: { title: '热门话题' }
  // },
  // {
  //   path: routeNames.recommendPost,
  //   component: () => import('../../pages/homeManagement/recommendPost/list'),
  //   meta: { title: '推荐帖子' }
  // },
  // {
  //   path: routeNames.taskSquare,
  //   component: () => import('../../pages/homeManagement/taskSquare/list'),
  //   meta: { title: '任务广场' }
  // },
  // {
  //   path: routeNames.tryProduct,
  //   component: () => import('../../pages/homeManagement/tryProduct/list'),
  //   meta: { title: '试用商品' }
  // },
  // {
  //   path: routeNames.integralProduct,
  //   component: () => import('../../pages/homeManagement/integralProduct/list'),
  //   meta: { title: '积分商品' }
  // }
] as TRoutes[]
